<template>
  <div id="map" style="height: 100vh; width: 100%"></div>
</template>

<script>
export default {
  name: 'MapView',
  props: {
    centerLat: {
      type: Number,
      required: true,
    },
    centerLng: {
      type: Number,
      required: true,
    },
    zoom: {
      type: Number,
      default: 13,
    },
    locations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      map: null,
      markers: [], // lưu các marker để clear sau này,
      islandMarkers: [],
    };
  },
  mounted() {
    console.log('Initial Locations:', this.locations);
    if (typeof window.L === 'undefined') {
      console.error('Leaflet chưa được load. Kiểm tra lại CDN.');
      return;
    }

    this.map = window.L.map('map', { zoomControl: false }).setView([this.centerLat, this.centerLng], this.zoom);

    window.L.control.zoom({ position: 'bottomright' }).addTo(this.map);

    this.map.panBy([-200, 100]);

    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
    }).addTo(this.map);

    this.renderMarkers(this.locations);
    this.renderVietnamIslands();
  },
  watch: {
    locations: {
      handler(newLocations) {
        this.renderMarkers(newLocations);
      },
      deep: true,
    },
  },
  methods: {
    renderMarkers(locations) {
      // Xóa marker cũ
      this.markers.forEach(marker => this.map.removeLayer(marker));
      this.markers = [];

      const redIcon = new window.L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });

      // Thêm marker mới
      locations.forEach(loc => {
        const lat = parseFloat(loc.lat);
        const lng = parseFloat(loc.lng);

        if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
          console.warn('Locations không có toạ độ:', loc);
          return;
        }

        const marker = window.L.marker([lat, lng], { icon: redIcon })
          .addTo(this.map)
          .bindPopup(`<strong>${loc.product_name}</strong><br/>Count: ${loc.count || 0}`);
        this.markers.push(marker);
      });
    },
    renderVietnamIslands() {
      this.islandMarkers.forEach(marker => this.map.removeLayer(marker));
      this.islandMarkers = [];

      const vietnamFlagIcon = new window.L.Icon({
        iconUrl: 'https://flagcdn.com/vn.svg',
        iconSize: [40, 30],
        iconAnchor: [20, 15],
        popupAnchor: [0, -15],
      });

      const islands = [
        {
          name: 'Hoàng Sa',
          lat: 16.7,
          lng: 112.5,
          vietnamese: 'Hoàng Sa là của Việt Nam 🇻🇳',
          chinese: '黄沙、西沙群岛属于越南 🇻🇳',
          english: 'The Paracel Islands belong to Vietnam 🇻🇳',
        },
        {
          name: 'Trường Sa',
          lat: 9.5,
          lng: 113,
          vietnamese: 'Trường Sa là của Việt Nam 🇻🇳',
          chinese: '黄沙、西沙群岛属于越南 🇻🇳',
          english: 'The Spratly Islands belong to Vietnam 🇻🇳',
        },
      ];

      islands.forEach(island => {
        const marker = window.L.marker([island.lat, island.lng], { icon: vietnamFlagIcon })
          .addTo(this.map)
          .bindPopup(
            `<strong>${island.vietnamese}</strong><br/><strong>${island.chinese}</strong><br/><strong>${island.english}</strong>`,
          );
        this.islandMarkers.push(marker);
      });
    },
  },
};
</script>

<style scoped>
#map {
  border: 1px solid #ccc;
  position: absolute;
  top: 0;
  z-index: 0;
}
</style>
